import * as React from 'react'
import {useEffect, useState} from 'react'
import * as routes from '../../constants/routes'
import {useTranslation} from 'react-i18next'
import {Link} from 'gatsby-plugin-react-i18next'

const PresentationButton = () => {
    const {t} = useTranslation()
    const [hasEmbeddedForm, setHasEmbeddedForm] = useState(false)

    useEffect(() => {
        setHasEmbeddedForm(!!document.getElementById('presentation-form'))
    }, [])

    const classNames = 'btn button is-primary is-large is-rounded is-fullwidth-mobile'

    if (hasEmbeddedForm) {
        return (
            <a id="presentation" className={classNames} role={'button'} href={'#presentation-form'}>
                {t('invite-section_presentation')}
            </a>
        )
    }

    return (
        //Analytics id="presentation"
        <Link id="presentation" className={classNames} to={routes.PRESENTATION_FORM} role={'button'}>
            {t('invite-section_presentation')}
        </Link>
    )
}

export default PresentationButton
